import deepClone from '../../foundation/js/deepClone'


export default {
    namespaced: true,
    state: {
        display_order_history_table_data : undefined,
        original_order_history_table_data : undefined,
        order_history_take_amount : 5,
        accumulated_order_history_take_amount : 0,
    },
    mutations:{
        set_display_order_history_table_data(state, data) {
            data.entries = data.entries.slice(0, state.accumulated_order_history_take_amount)
            state.display_order_history_table_data = data
        },
        set_original_order_history_table_data(state, payload) {
            state.original_order_history_table_data = payload
        },
        set_accumulated_order_history_take_amount(state, payload) {
            state.accumulated_order_history_take_amount = payload
        }
    },
    actions:{
        setOrderHistory(context, payload){
            context.commit('set_accumulated_order_history_take_amount', context.state.order_history_take_amount)
            context.commit('set_display_order_history_table_data', deepClone(payload))
            context.commit('set_original_order_history_table_data', deepClone(payload))
        },
        showMoreOrders(context){
            const newAccValue = context.state.accumulated_order_history_take_amount + context.state.order_history_take_amount
            const originalData = deepClone(context.state.original_order_history_table_data)
            context.commit('set_accumulated_order_history_take_amount', newAccValue)
            context.commit('set_display_order_history_table_data', originalData)
        }
    }
}
